/**
 * Validazione allegati per commenti task
 */

export const ALLOWED_COMMENT_ATTACHMENT_TYPES = [
  // Immagini
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  // Documenti
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];

export const MAX_COMMENT_ATTACHMENTS = 5;
export const MAX_COMMENT_ATTACHMENT_SIZE = 50 * 1024 * 1024; // 50MB

export function isImageType(type: string): boolean {
  return type.startsWith('image/');
}

export function validateCommentAttachment(file: File): { valid: boolean; error?: string } {
  if (!ALLOWED_COMMENT_ATTACHMENT_TYPES.includes(file.type)) {
    return {
      valid: false,
      error: `Tipo file non supportato. Sono ammessi: immagini (JPG, PNG, GIF, WebP) e documenti (PDF, Word, Excel).`
    };
  }

  if (file.size > MAX_COMMENT_ATTACHMENT_SIZE) {
    return {
      valid: false,
      error: `File troppo grande (${(file.size / 1024 / 1024).toFixed(1)}MB). Massimo 50MB.`
    };
  }

  return { valid: true };
}

export function validateAttachmentCount(currentCount: number, newCount: number): { valid: boolean; error?: string } {
  if (currentCount + newCount > MAX_COMMENT_ATTACHMENTS) {
    return {
      valid: false,
      error: `Massimo ${MAX_COMMENT_ATTACHMENTS} allegati per commento. Attualmente: ${currentCount}.`
    };
  }
  return { valid: true };
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}
